import React from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import CustomerHelper from "../../globalHelpers/CustomerHelper";
import { WidthProvider, Responsive } from "react-grid-layout";
import _ from "lodash";
import WidgetViewer from "./WidgetViewer";
import StateTree from "../../globalHelpers/StateTree";
import Spinner from "../Components/Spinner";

//View Helpers
import { toast } from "react-toastify";
import { isIOS } from "react-device-detect";

import T2 from "./T2";
import CryptoJS from "crypto-js";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const overrideBottomPositions = {
    BOTTOM: true,
};

const overrideTopPositions = {
    TOP: true,
};

function fetchSessionAll({ sessionId }) {
    try {
        Express.call(
            "fetch-session",
            {
                sessionId,
            },
            (results) => {
                if (results) {
                    const sessionKeys = Object.keys(results);

                    for (let i = 0; i < sessionKeys.length; i++) {
                        const sessionKey = sessionKeys[i];
                        const sessionData = results[sessionKey];

                        StateTree.update(sessionKey, sessionData);
                    }
                }
            },
        );
    } catch (e) {
        console.log(e);
    }
}

/**
 * This layout demonstrates how to sync multiple responsive layouts to localstorage.
 */
export default class PageViewer extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            layouts: JSON.parse(JSON.stringify([])),
            render: true,
        };

        this.addNew = this.addNew.bind(this);
        this.save = this.save.bind(this);
        this.edit = this.edit.bind(this);

        this.applicationWidth = window.innerWidth;
        this.applicationView = "desktop";
        this.viewConstraints = {
            desktop: 1200,
            tablet: 625,
            cell: 218,
        };
        this.previousView = "desktop";
        this.calculateView();
        window.onresize = (event) => {
            this.calculateView();
            window.localStorage.setItem(
                "application-view",
                this.applicationView,
            );
            if (this.previousView != this.applicationView) {
                this.refresh((state) => {
                    window.location.reload(true);
                });
            }
            // window.location.reload(true);
        };
    }

    refresh(callback) {
        const pageName = this.props.pageName || window.location.pathname;

        this.fetchWidgetLayout(pageName, async (results) => {
            this.setState(
                {
                    widgetLayout: results.widgetLayout,
                    layout: results.layout,
                    layouts: results.layouts,
                },
                () => {
                    if (callback) {
                        callback(this.state);
                    }
                },
            );
        });
    }

    async checkAccess(layout) {
        try {
            const sessionId = Express.getSessionId();
            const userId = await CustomerHelper.fetchUserId();

            let skip = false;

            if (!sessionId && !userId) {
                skip = true;
            }

            const results = [];
            const tags = [];
            const tagIndex = {};

            for (let i = 0; i < layout.length; i++) {
                const widget = layout[i];
                let widgetName = widget.i;

                if (typeof widgetName == typeof {}) {
                    widgetName = Object.keys(widget.i)[0];
                }

                if (skip) {
                    widget.hasAccess = true;
                }

                tags.push(widgetName);
                tagIndex[widgetName] = i;

                results.push(widget);
            }

            if (skip) {
                return results;
            }

            const accessCheck = await Express.call("check-user-access", {
                userId,
                sessionId,
                accessTags: tags,
                detailed: true,
            });

            for (let i = 0; i < results.length; i++) {
                const widget = results[i];
                let widgetName = widget.i;

                const hasAccess = accessCheck[widgetName];

                if (widget.allAccess) {
                    results[i].hasAccess = true;
                } else {
                    results[i].hasAccess = hasAccess;
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    componentWillMount() {
        const sessionId = window.sessionStorage.getItem("sessionId");
        if (sessionId) {
            fetchSessionAll({ sessionId });

            let origin = window.location.origin;

            if (origin.includes("localhost")) {
                origin = origin.replace(":1234", ":3000");
            }

            origin = origin.replace("http:", "ws:");
            origin = origin.replace("https:", "wss:");

            // this.fetchSessionAll({ sessionId });

            // setInterval(() => {
            //     this.fetchSessionAll({ sessionId });
            // }, 1000);

            const websocket = new WebSocket(
                origin + "/websockets?sessionId=" + sessionId,
            );
            websocket.connectionId = sessionId;

            websocket.onmessage = function (event) {
                if (event.data) {
                    try {
                        const decodedMessage = decode(
                            event.data,
                            event.target.connectionId.substring(0, 32),
                        );

                        const messageObject = JSON.parse(decodedMessage);

                        const { key, sessionData } = messageObject;
                        if (key && sessionData) {
                            StateTree.update(key, sessionData);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            };

            Express.call("validate-session", { sessionId });
        }

        this.calculateView();
        this.refresh();

        const globalMessage = window.localStorage.getItem("globalMessage");

        if (globalMessage) {
            toast.success(globalMessage);
            window.localStorage.removeItem("globalMessage");
        }

        StateTree.subscribe("renderGrid", (render) => {
            this.setState({ render });
        });
    }

    fetchWidgetLayout(pageName, callback) {
        Express.callPublic("fetch-page", { route: pageName }, (page) => {
            if (page) {
                Express.callPublic(
                    "fetch-page-layout",
                    { pageName: page.pageLayout },
                    (pageLayout) => {
                        try {
                            if (!pageLayout || !pageLayout.layout) {
                                window.location.href = "/";
                            }

                            callback({
                                widgetLayout: pageLayout.layout,
                                layout: pageLayout.layout[this.applicationView],
                                layouts:
                                    pageLayout.layout[this.applicationView],
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    },
                );
            } else {
                window.location.href = "/";
                return {};
            }
        });
    }

    static get defaultProps() {
        return {
            className: "layout",
            cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
            rowHeight: 30,
        };
    }

    onLayoutChange(layout, layouts) {
        this.setState({ layout, layouts });
    }

    addNew() {
        const widgets = this.state.widgetLayout;
        widgets[this.applicationView].push({
            "data-grid": {
                w: 2,
                h: 3,
                x: 0,
                y: 0,
                minW: 2,
                minH: 3,
            },
            i: "0",
        });
        // this.setState({ widgetLayout: widgets, layouts: {} });
    }

    save() {
        const widgetList = this.state.widgetLayout;
        _.map(widgetList[this.applicationView], (widget) => {
            widget["data-grid"].static = true;
        });

        const layout = this.state.layout;
        _.map(layout, (item) => {
            item.static = true;
        });

        const layouts = {};
        saveToLS(this.applicationView, this.state.layouts);
        saveToLS(this.applicationView + "ls", this.state.layout);
        window.location.reload(true);

        // this.setState({ widgetLayout: widgetList, layout, layouts });
    }

    edit() {
        const widgets = this.state.widgetLayout;

        _.map(widgets[this.applicationView], (widget) => {
            widget["data-grid"].static = false;
        });

        const layout = this.state.layout;
        _.map(layout, (item) => {
            item.static = false;
        });

        saveToLS(this.applicationView + "ls", layout);
        window.location.reload(true);

        // this.setState({ widgetLayout: widgets, layouts: {}, layout });
    }

    renderWidget(widget) {
        try {
            let widgetName = widget.i;
            if (typeof widget.i == typeof {}) {
                widgetName = Object.keys(widget.i)[0];
            }
            return <WidgetViewer widgetName={widgetName} widget={widget} />;
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }

    render() {
        if (!this.state.widgetLayout) {
            return (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                    }}
                >
                    <Spinner width="50px" />
                    <br />
                    <span>
                        <T2 id="1141">Loading customer data...</T2>
                    </span>
                </div>
            );
        }

        let bottomWidgets = [];
        for (
            let i = 0;
            i < this.state.widgetLayout[this.applicationView].length;
            i++
        ) {
            const widget = this.state.widgetLayout[this.applicationView][i];
            if (overrideBottomPositions[widget.overridePosition]) {
                bottomWidgets.push(widget);
            }
        }

        let topWidgets = [];
        for (
            let i = 0;
            i < this.state.widgetLayout[this.applicationView].length;
            i++
        ) {
            const widget = this.state.widgetLayout[this.applicationView][i];
            if (overrideTopPositions[widget.overridePosition]) {
                topWidgets.push(widget);
            }
        }

        return (
            <div>
                {_.map(topWidgets, (widget) => {
                    if (this.state.render || widget.alwaysRender) {
                        const overrideStyle =
                            this.applicationView !== "desktop"
                                ? {
                                      ...widget.overrideStyle,
                                  }
                                : {};

                        return (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    ...overrideStyle,
                                }}
                            >
                                {this.renderWidget(widget)}
                            </div>
                        );
                    }
                })}

                {this.state.render && (
                    <main role="main" id="main-content">
                        <ResponsiveReactGridLayout
                            className="layout"
                            autoSize={true}
                            cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                            containerPadding={[0, 0]}
                            rowHeight={10}
                            onLayoutChange={(layout, layouts) =>
                                this.onLayoutChange(layout, layouts)
                            }
                        >
                            {_.map(
                                this.state.widgetLayout[this.applicationView],
                                (widget, index) => {
                                    let tmpWidget = { ...widget };

                                    if (tmpWidget.overridePosition) {
                                        // bottomWidgets.push(widget);
                                        tmpWidget.i = "Empty";
                                        tmpWidget.hideHeader = true;
                                        return <span />;
                                    }
                                    return (
                                        <div
                                            key={index + ""}
                                            data-grid={{
                                                ...tmpWidget["data-grid"],
                                            }}
                                            style={tmpWidget.style}
                                        >
                                            {tmpWidget["data-grid"] &&
                                                !tmpWidget["data-grid"]
                                                    .static && (
                                                    <div>
                                                        {JSON.stringify(
                                                            this.state.layout[
                                                                index
                                                            ],
                                                        )}
                                                    </div>
                                                )}
                                            {this.renderWidget(tmpWidget)}
                                        </div>
                                    );
                                },
                            )}
                        </ResponsiveReactGridLayout>
                    </main>
                )}

                {_.map(bottomWidgets, (widget) => {
                    if (this.state.render || widget.alwaysRender) {
                        const overrideStyle =
                            this.applicationView !== "desktop"
                                ? {
                                      ...widget.overrideStyle,
                                  }
                                : {};

                        return (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    ...overrideStyle,
                                }}
                            >
                                {this.renderWidget(widget)}
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    calculateView() {
        this.previousView = this.applicationView;
        const previousWidth = window.localStorage.getItem("width");
        const width = window.innerWidth;
        const height = window.innerHeight;
        window.localStorage.setItem("width", window.innerWidth);
        const landscape = width > height + 100;
        for (const key in this.viewConstraints) {
            const constraint = this.viewConstraints[key];
            if (width >= constraint) {
                this.applicationView = key;
                break;
            }

            this.applicationView = "cell";
        }
        if (this.applicationView == "cell" && landscape) {
            this.applicationView = "tablet";
        } else if (
            this.applicationView == "tablet" &&
            landscape &&
            isIOS &&
            previousWidth != null &&
            previousWidth != width
        ) {
            this.refresh((state) => {
                window.location.reload(true);
            });
        }
    }
}

function getFromLS(key) {
    let ls = {};
    if (global.localStorage) {
        try {
            ls = JSON.parse(global.localStorage.getItem(key)) || {};
        } catch (e) {
            /*Ignore*/
        }
    }
    return ls;
}

function saveToLS(key, value) {
    if (global.localStorage) {
        global.localStorage.setItem(key, JSON.stringify(value));
    }
}

function decode(input, key) {
    try {
        var keys = CryptoJS.enc.Utf8.parse(key);
        let base64 = CryptoJS.enc.Base64.parse(input);
        let src = CryptoJS.enc.Base64.stringify(base64);
        var decrypt = CryptoJS.AES.decrypt(src, keys, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        });

        return decrypt.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.log(e);
        return input;
    }
}
